var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHome(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 20,
    viewBox: "0 0 18 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.133 19.0003C1.955 19.0003 1 18.0203 1 16.8103V8.00828C1 7.34328 1.295 6.71328 1.8 6.29828L7.667 1.48028C8.04186 1.16986 8.5133 1 9 1C9.4867 1 9.95814 1.16986 10.333 1.48028L16.199 6.29828C16.705 6.71328 17 7.34328 17 8.00828V16.8103C17 18.0203 16.045 19.0003 14.867 19.0003H3.133Z",
    stroke: "#DABB27",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.5 19V13.5C6.5 12.9696 6.71071 12.4609 7.08579 12.0858C7.46086 11.7107 7.96957 11.5 8.5 11.5H9.5C10.0304 11.5 10.5391 11.7107 10.9142 12.0858C11.2893 12.4609 11.5 12.9696 11.5 13.5V19",
    stroke: "#DABB27",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHome);
export default __webpack_public_path__ + "static/media/Home.98652a768683d38b1186a86d92fe0370.svg";
export { ForwardRef as ReactComponent };